import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { SEOHead } from "@/components/SEOHead";
import { HeroSection } from "@/components/home/HeroSection";
import { FeaturedResearchSection } from "@/components/home/FeaturedResearchSection";
import { MediaSection } from "@/components/home/MediaSection";
import { IntelligenceBriefsCapture } from "@/components/home/IntelligenceBriefsCapture";
import { HomeContactBlock } from "@/components/home/HomeContactBlock";
import { StateOfTheSystemSection } from "@/components/home/StateOfTheSystemSection";
import { FieldNotesSection } from "@/components/home/FieldNotesSection";
import { WorkStrip } from "@/components/home/WorkStrip";
import { RHTPClock } from "@/components/rhtp/RHTPClock";

const Index = () => {
  return (
    <PublicLayout>
      <SEOHead url="https://davidisei.com/" />
      <HeroSection />
      <FeaturedResearchSection />

      <StateOfTheSystemSection />

      <section aria-labelledby="rhtp-home" className="border-t border-border/60 py-16 sm:py-20">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-liberty-gold">
            Rural Health Transformation Program
          </p>
          <h2 id="rhtp-home" className="mt-3 font-display text-3xl font-bold text-foreground sm:text-4xl">
            The RHTP Clock
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-foreground/85">
            The Rural Health Transformation Program (RHTP) is a federal program, created by Public Law 119-21, that sends funding through CMS to states to strengthen rural healthcare. Hawaiʻi's award is the largest single investment in rural care the state has seen. The clock tracks the program's key dates.
          </p>
          <div className="mt-6">
            <RHTPClock compact />
          </div>
          <Link
            to="/rhtp"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-liberty-gold hover:opacity-80"
          >
            How the money should be judged <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>

      <WorkStrip />

      <FieldNotesSection />
      <MediaSection />
      <IntelligenceBriefsCapture />
      <HomeContactBlock />
    </PublicLayout>
  );
};

export default Index;
